"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=attribute.js.map